export default __webpack_public_path__ + "static/media/sidemenu_phi_profile.9b876531.svg";